import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy creator URL — permanently redirects to the new /user/$slug page. */
export const Route = createFileRoute("/u/$handle")({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/user/$slug",
      params: { slug: params.handle },
      search: { ref: (search as { ref?: string }).ref },
      replace: true,
    });
  },
});
